import React, { useEffect, useRef } from 'react';

import { UserAvatar } from '@/components/UserAvatar/UserAvatar';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';

import styles from './MentionPicker.module.scss';

export interface MentionMember {
	id: string;
	displayName?: string | null;
}

interface MentionPickerProps {
	members: MentionMember[];
	activeIndex: number;
	onSelect: (member: MentionMember) => void;
}

export const MentionPicker: React.FC<MentionPickerProps> = ({
	members,
	activeIndex,
	onSelect,
}) => {
	const listRef = useRef<HTMLUListElement>(null);

	useEffect(() => {
		const item = listRef.current?.children[activeIndex] as HTMLElement | undefined;
		item?.scrollIntoView({ block: 'nearest' });
	}, [activeIndex]);

	const fireMentionSelect = useAnalyticsEvent('Chat_Mention_Select');

	if (members.length === 0) return null;

	return (
		<div className={styles['mention-picker']}>
			<ul className={styles['mention-picker__list']} ref={listRef}>
				{members.map((member, index) => (
					<li
						key={member.id}
						className={[
							styles['mention-picker__item'],
							index === activeIndex ? styles['mention-picker__item--active'] : '',
						]
							.filter(Boolean)
							.join(' ')}
						onMouseDown={(e) => {
							// onMouseDown prevents input blur before selection fires
							e.preventDefault();
							fireMentionSelect();
							onSelect(member);
						}}
					>
						<UserAvatar
							userId={member.id}
							size="xx-small"
							showActiveStatus={false}
						/>
						<span className={styles['mention-picker__name']}>
							{member.displayName ?? ''}
						</span>
					</li>
				))}
			</ul>
		</div>
	);
};
